//New-products.js new file 

function getCushieActiveCurrency() {
  return (
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.isoCode) ||
    (window.theme && window.theme.currencyCode) ||
    'USD'
  );
}


function normalizeCushieMoneyPrefix(text) {
  return String(text || '').replace(/\bCA\$/g, '$').replace(/\bCAD\s*\$/g, '$');
}

function cleanCushieCanadianPricePrefixes(root) {
  const currency = getCushieActiveCurrency();
  const isCanada = currency === 'CAD' || window.location.hostname.indexOf('ca.') === 0;
  if (!isCanada) return;
  const scope = root || document;
  const selectors = [
    '.variant-price', '.original-price', '.sale-Price', '.comp-Price', '.product-price',
    '.spf-product-card__saleprice', '.spf-product-card__oldprice', '.spf-product-card__price',
    '.cart_main_price', '.cart_cross_price', '.cart_sub_total_price', '#price-all-cart',
    '.brk_price', '.current-price', '.compare-at', '.money'
  ];
  scope.querySelectorAll(selectors.join(',')).forEach((el) => {
    if (el.childNodes.length === 1 && el.childNodes[0].nodeType === Node.TEXT_NODE) {
      el.textContent = normalizeCushieMoneyPrefix(el.textContent);
    }
  });
}

window.normalizeCushieMoneyPrefix = normalizeCushieMoneyPrefix;
window.cleanCushieCanadianPricePrefixes = cleanCushieCanadianPricePrefixes;

document.addEventListener('DOMContentLoaded', function () {
  cleanCushieCanadianPricePrefixes(document);
});
window.addEventListener('globoFilterRenderCompleted', function () {
  cleanCushieCanadianPricePrefixes(document);
});
setTimeout(function () { cleanCushieCanadianPricePrefixes(document); }, 800);

function formatCushieMoney(amount) {
  const value = Number(amount) || 0;
  const currency = getCushieActiveCurrency();
  try {
    return normalizeCushieMoneyPrefix(value.toLocaleString(undefined, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));
  } catch (error) {
    const symbol = currency === 'GBP' ? '£' : '$';
    return normalizeCushieMoneyPrefix(symbol + value.toFixed(2));
  }
}

function removeSkeleton(imgElement) {
  $(imgElement).siblings('.skeleton').fadeOut(300, function() {
    $(this).remove();
  });
}

async function fetchInventory(variantId) {
  try {
    const cleanId = parseInt(variantId, 10);
    if (isNaN(cleanId)) {
      console.error('fetchInventory: invalid variantId', variantId);
      return [];
    }

    const res = await fetch(
      `https://scripts.lifely.network/cloudflare/worker/cushie-inventory-status/inventory-api.php?variant_id=${variantId}`,
      { cache: 'no-store' }
    );

    if (!res.ok) {
      console.error('fetchInventory: HTTP error', res.status, res.statusText);
      return [];
    }

    const data = await res.json();

    if (!data.locations || data.locations.length === 0) {
      console.warn('fetchInventory: no locations returned for variant', cleanId);
      return [];
    }

    return data.locations.map(loc => ({
      location: loc.location,
      quantity: loc.available
    }));

  } catch (err) {
    console.error('fetchInventory: fetch failed', err);
    return [];
  }
}



function variantAllowsPreOrder(variantId) {
  var policy = $('.variant_estimate_date[data-variant="' + variantId + '"]').attr('variant-inventory-policy');
  return policy === 'continue';
}

function enablePrimaryCartButton() {
  $('#primar-button').prop('disabled', false).removeAttr('aria-disabled');
}

function renderSoldOutStockStatus() {
  $('.stock-status-card .shipment-header').html(`<span class="status-dot pre-order">
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9.5" r="5" fill="#BA3F3F"></circle>
    <circle cx="9" cy="9.5" r="6.875" stroke="#BA3F3F" stroke-opacity="0.3" stroke-width="3.75"></circle>
    </svg>
  </span><strong>Sold Out</strong>`);
  $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('Current Batch');
  $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html(`<strong>Sold Out</strong>`);
  $('#primar-button').val('Sold Out');
  $('#primar-button').attr('data-value', 'Sold Out');
  $('#primar-button').prop('disabled', true).attr('aria-disabled', 'true');
  $('#primar-button').closest('.atcButtonWrap').find('.cart_pre_order_icon').attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/timer.png?v=1747280079');
  $('.stock-status-card').removeClass('loading');
}

function renderPreOrderOrSoldOut(variantId, preorderText, deliveryDate) {
  if (variantAllowsPreOrder(variantId)) {
    if(preorderText && preorderText != 'undefined'){
      $('.stock-status-card .shipment-header').html(`<span class="status-dot pre-order">
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9.5" r="5" fill="#BA3F3F"></circle>
        <circle cx="9" cy="9.5" r="6.875" stroke="#BA3F3F" stroke-opacity="0.3" stroke-width="3.75"></circle>
        </svg>
      </span><strong>Pre Order, ${preorderText}</strong>`);
      $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('Next Batch Ships in');
      $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html(`<strong>${deliveryDate}</strong>`);
      $('.variant_estimate_date[data-variant="' + variantId + '"]').attr('data-ship-date', deliveryDate);
      $('#primar-button').val('Pre-Order');
      $('#primar-button').attr('data-value', 'Pre-Order');
      enablePrimaryCartButton();
      $('#primar-button').closest('.atcButtonWrap').find('.cart_pre_order_icon').attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/timer.png?v=1747280079');
      $('.stock-status-card').removeClass('loading');
    }
  }else{
    renderSoldOutStockStatus();
  }
}


// updated jquery to show comma seprated price 
jQuery(document).ready(function ($) {
  function updatePricing() {
    if (!$(".pricing-block").length) return;

    let current_variant_id = "";
    let selected_variant_title = "";

    // --- Build selected variant title dynamically ---
    const $variantOptions = $(".variant-productOption");
    const total_options = $variantOptions.length;

    if (total_options > 0) {
      const option1 =
        $('.variant-productOption[data-option-id="0"] .active').attr(
          "data-value"
        ) || "";
      const option2 =
        $('.variant-productOption[data-option-id="1"] .active').attr(
          "data-value"
        ) || "";
      const option3 =
        $('.variant-productOption[data-option-id="2"] .active').attr(
          "data-value"
        ) || "";

      if (total_options === 1) {
        selected_variant_title = option1;
      } else if (total_options === 2) {
        selected_variant_title = `${option1} / ${option2}`;
      } else if (total_options === 3) {
        selected_variant_title = `${option1} / ${option2} / ${option3}`;
      }

      selected_variant_title = selected_variant_title.trim();
      if (selected_variant_title) {
        // Use attribute equals selector safely (with quotes escaped)
        const safeTitle = CSS.escape(selected_variant_title);
        current_variant_id = $(".pdpVariantData li[data-title='" + safeTitle + "']").attr("data-vid") || "";
      }
    }

    if (!selected_variant_title) return;

    const $variant = $(".pdpVariantData li[data-title='" + selected_variant_title + "']");

    if (!$variant.length) {
      $(".pricing-block .sale-Price, .pricing-block .comp-Price, .pricing-block .discount-Percent, .PDP-OFFER p.sale-price.sp-grid-pdp").empty();
      $(".pdp-offer-container").addClass("hide");
      return;
    }

    // --- Get prices ---
    let sale_price = parseFloat($variant.attr("data-price")) / 100 || 0;
    let compare_price = parseFloat($variant.attr("data-comp-price")) / 100 || 0;
    let sale_title = $variant.attr("data-sale-title");

    let formattedSalePrice = normalizeCushieMoneyPrefix(sale_price.toLocaleString("en-US", {
      style: "currency",
      currency: getCushieActiveCurrency(),
      currencyDisplay: 'narrowSymbol',
    }));

    let formattedCompPrice = normalizeCushieMoneyPrefix(compare_price.toLocaleString("en-US", {
      style: "currency",
      currency: getCushieActiveCurrency(),
      currencyDisplay: 'narrowSymbol',
    }));

    if (sale_price > 0) {
    let discountText = "";
    let difference = 0;
    let discountPercent = 0;

    if (compare_price > sale_price) {
      difference = compare_price - sale_price;
      discountPercent = Math.round((difference / compare_price) * 100);
      discountText = discountPercent > 0 ? discountPercent + "% OFF" : "";
    }

    const hasSavings = difference > 0 && discountPercent > 0;

    // Format saved amount with commas
    const formattedDifference = normalizeCushieMoneyPrefix(difference.toLocaleString("en-US", {
      style: "currency",
      currency: getCushieActiveCurrency(),
      currencyDisplay: 'narrowSymbol',
    }));

  // ✅ Use locale formatting (with commas)
  const formattedSalePrice = normalizeCushieMoneyPrefix(sale_price.toLocaleString("en-US", {
    style: "currency",
    currency: getCushieActiveCurrency(),
    currencyDisplay: 'narrowSymbol',
  }));

  const formattedCompPrice = normalizeCushieMoneyPrefix(compare_price.toLocaleString("en-US", {
    style: "currency",
    currency: getCushieActiveCurrency(),
    currencyDisplay: 'narrowSymbol',
  }));

  $(".pricing-block .sale-Price").text(formattedSalePrice);
  $(".pricing-block .comp-Price").text(hasSavings ? formattedCompPrice : "").toggle(hasSavings);
  $(".pricing-block .discount-Percent").text(hasSavings ? discountText : "").toggle(hasSavings);
  // $(".PDP_Sale_label .saleLabel").text(sale_title);

  $(".PDP-OFFER p.sale-price.sp-grid-pdp").text(
    hasSavings ? `You Saved: ${formattedDifference}` : ""
  ).toggle(hasSavings);

  $(".pdp-offer-container").toggleClass("hide", !hasSavings);
} else {
  $(".pdp-offer-container").addClass("hide");
}

  }

  setTimeout(function () {
    // --- Run on page load ---
    updatePricing();
  }, 1000);

  // --- Re-run on variant selection change ---
  $(document).on("click",".variant-productOption .config-item, .variant-productOption .product_color_values, .variant-productOption .seater-variant",
    function () {
      setTimeout(function () { updatePricing(); cleanCushieCanadianPricePrefixes(document); }, 100);
    }
  );
});

document.addEventListener("DOMContentLoaded", function() {
  const videos = document.querySelectorAll(".video_content");

  function loadAndPlayVideo(videoWrapper) {
    const video = videoWrapper.querySelector("video");
    const source = video.querySelector("source");
    const videoUrl = videoWrapper.getAttribute("data-video");

    if (!source.getAttribute("src")) {
      source.setAttribute("src", videoUrl);
      video.load();
      video.play().catch(() => {
        // Autoplay might be blocked on some browsers (esp. Safari without muted)
        console.log("Autoplay blocked, user interaction required.");
      });
    }
  }

  function handleScroll() {
    videos.forEach(wrapper => {
      const rect = wrapper.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
      if (isVisible) {
        loadAndPlayVideo(wrapper);
      }
    });
  }

  // Run once on load (covers "already visible" case)
  handleScroll();

  // Also run on scroll
  window.addEventListener("scroll", handleScroll, { passive: true });

});



document.addEventListener("DOMContentLoaded", function() {
  const lazyVideos = document.querySelectorAll(".lazy-video");

  function loadAndPlay(wrapper) {
    const video = wrapper.querySelector("video");
    const source = video.querySelector("source");
    const videoUrl = wrapper.getAttribute("data-video");

    if (!source.getAttribute("src")) {
      source.setAttribute("src", videoUrl);
      video.load();
      video.play().catch(() => {
        console.log("Autoplay blocked, user interaction required.");
      });
    }
  }

  function checkVisibility() {
    lazyVideos.forEach(wrapper => {
      const rect = wrapper.getBoundingClientRect();
      const visible = rect.top < window.innerHeight && rect.bottom > 0;
      if (visible) {
        loadAndPlay(wrapper);
      }
    });
  }

  // Check immediately (for already visible videos)
  checkVisibility();

  // Check again on scroll
  window.addEventListener("scroll", checkVisibility, { passive: true });
});



$(document).ready(function(){

  $('.add-to-cart-holder .atcButtonWrap input.add-to-cart-button').on('click', function(){
    var $btn = $(this); // save reference
    $btn.find('img.cart-icon3').hide();
  });

  // 1️⃣ Initialize shimmer sliders so they look like working sliders
  const product_thumbs_swiper = new Swiper(`.heroGalleryWrapper.originalGallery .product_meta_swiper`, {
    slidesPerView: 4,
    watchSlidesProgress: true,
    spaceBetween: 20,
    grabCursor: true,
    breakpoints: {
      300: {
        slidesPerView: 5,
        spaceBetween: 5,
        showSwitchArrows: false
      },
      1150: {
        slidesPerView: 4,
        spaceBetween: 10,
        showSwitchArrows: false
      }
    }
  });

  const main_slider = new Swiper(`.heroGalleryWrapper.originalGallery .product_main_slider`, {
    slidesPerView: 1,
    spaceBetween: 10,
    watchOverflow: false,
    thumbs: {
      swiper: product_thumbs_swiper
    }
  });


  // 1️⃣ Initialize shimmer sliders so they look like working sliders
  const product_thumbs_swiper_lifestyle = new Swiper(`.heroGalleryWrapper.lifestyleGallery .product_meta_swiper`, {
    slidesPerView: 4,
    watchSlidesProgress: true,
    spaceBetween: 20,
    grabCursor: true,
    breakpoints: {
      300: {
        slidesPerView: 5,
        spaceBetween: 5,
        showSwitchArrows: false
      },
      1150: {
        slidesPerView: 4,
        spaceBetween: 10,
        showSwitchArrows: false
      }
    }
  });

  const main_slider_lifestyle = new Swiper(`.heroGalleryWrapper.lifestyleGallery .product_main_slider`, {
    slidesPerView: 1,
    spaceBetween: 10,
    watchOverflow: false,
    thumbs: {
      swiper: product_thumbs_swiper
    }
  });


  /* var current_variant_id = '';
  if($('.heroGalleryWrapper.originalGallery').length > 0){
    current_variant_id = $('.heroGalleryWrapper.originalGallery').attr('data-current-variant');
    if(current_variant_id != '' && current_variant_id != 'undefined' && current_variant_id != null){
      setTimeout(function(){
        renderProductGalleryByVariantId(current_variant_id);
      }, 1000);
    }
  } */


  /* if($('.heroGalleryWrapper.lifestyleGallery').length > 0){
    current_variant_id = $('.heroGalleryWrapper.lifestyleGallery').attr('data-current-variant');
    if(current_variant_id != '' && current_variant_id != 'undefined' && current_variant_id != null){
      setTimeout(function(){
        renderProductGalleryLifestyleByVariantId(current_variant_id);
      }, 1000);
    }
  } */


   $(document).on('click', '.product_thumbnail_slider img.pdpThumbnailVideo', function () {
    var videoUrl = $(this).attr('data-video-url');
    var sourceHtml = $('.PdpVideoWrapper video').html();
    var index = $(this).closest('[data-slide]').attr('data-slide');
  
    if (!videoUrl || videoUrl === 'undefined') {
      console.warn('Invalid video URL');
      return;
    }
  
    $(this).closest('.hero-video').find('.product_media_list').each(function () {
      var slideIndex = $(this).attr('data-slide');
  
      if (index === slideIndex) {
        var $video = $(this).find('.pswp__custom-video-wrapper video');
        var $source = $video.find('source');
        var $img = $(this).find('.pswp__custom-video-wrapper img');
  
        // ✅ Only update src if different
        if ($source.attr('src') !== videoUrl) {
          /* $source.attr('src', videoUrl); */
          $video.html(sourceHtml);
          $video[0].load();
        }
  
        $video.removeClass('hide');
        $video[0].play();
  
        // Hide image when video plays
        $video.off('play').on('play', function () {
          $img.addClass('hide');
        });
  
      } else {
        // Pause and hide all other videos, show their images
        var $otherVideo = $(this).find('.pswp__custom-video-wrapper video');
        var $otherImg = $(this).find('.pswp__custom-video-wrapper img');
  
        $otherVideo[0]?.pause();
        $otherVideo.addClass('hide');
        $otherImg.removeClass('hide');
      }
    });
  });
  
  
  $(document).on('click', '.pdp-menu-left a', function (e) {
    e.preventDefault(); // Prevent default anchor behavior
    // console.log('afasff');
  
    const targetId = $(this).attr('href'); // e.g. "#shopify-section-..."
    const targetEl = $(targetId);
  
    if (targetEl.length) {
      $('html, body').animate({
        scrollTop: targetEl.offset().top
      }, 600); // 600ms animation
    }
  });

  $('.product_meta_size_guide').click(function(){
      $('.product_meta_size_guide_container').addClass('active_popup')
      $('.product_meta_size_guide.1seater').length && $('.product_size_table').css('width', '100%') && $('.sofa_meta_popup_size_image > img').css({'width': '80%',"display": "block","margin": "auto"});
  });
  $('.product_meta_close_size').click(function(){
       $('.product_meta_size_guide_container').removeClass('active_popup')
  })
  
  $('.seater-variant').hide();
  

  var active_config_name = $('.configuration-options .config-item.active_configure').attr('data-config-value') || '';
  var active_seater = $('.seater-variant.active').attr('seater-value') || '';
  var active_color = $('.product_color_values.active_color').attr('data-color') || '';

  // Grab variant ID from URL
  const urlParams = new URLSearchParams(window.location.search);
  const variantIdFromUrl = urlParams.get("variant");
  
  // Escape special characters for selector safety
  function escapeSelector(str) {
    if (!str) return str;
    return str.replace(/([ #;&,.+*~':"!^$[\]()=>|/@])/g, "\\$1");
  }
  
  if (variantIdFromUrl) {
    const targetVariant = $(`.modular_variants option[variant-id="${variantIdFromUrl}"]`);
  
    if (targetVariant.length) {
      // Dynamically collect all variant-option attributes
      const variantOptions = {};
      $.each(targetVariant[0].attributes, function () {
        if (this.name.startsWith("variant-option")) {
          const index = parseInt(this.name.split("variant-option")[1]) - 1;
          variantOptions[index] = this.value.trim();
        }
      });
  
      // Loop through .modular_variants select to get option names
      const optionNames = [];
      $(".modular_variants option").first().each(function () {
        $.each(this.attributes, function () {
          if (this.name.startsWith("variant-option")) {
            const i = parseInt(this.name.replace("variant-option", "")) - 1;
            optionNames[i] = this.name; // we use index to preserve order
          }
        });
      });

      // Now assign values based on actual option names (safe for 1, 2 or 3 option products)
      for (let i = 0; i < optionNames.length; i++) {
        const value = variantOptions[i];
        const name = $(`.modular_variants option`).first().attr(`variant-option${i + 1}`);
        const label = $(".variant-productOption-" + i).attr('data-option')?.toLowerCase() || '';


        // Apply config (Configuration or Size)
        if (label.includes("configuration") || label.includes("size")) {
          $(".configuration-options .config-item").removeClass("active_configure");
          $(".configuration-options .config-item").removeClass("active");
        
          const configItem = $(".configuration-options .config-item").filter(function () {
            return $(this).data("config-value") === value;
          });
        
          if (configItem.length) {
            configItem.addClass("active_configure");
            configItem.addClass("active");
            $("#selected-config").text(value);
          } else {
            console.warn("Config item not found for value:", value);
          }
        }
        
        // Apply seater
        if (label.includes("seater")) {
          $(".seater-variant").hide().removeClass("active");
        
          // Get main_variant from selected seater value
          const seaterValue = value;
          let main_variant = "sleeper"; // default fallback
        
          if (seaterValue.toLowerCase().includes("l-shaped")) {
            main_variant = "l-shaped";
          } else if (seaterValue.toLowerCase().includes("u-shaped")) {
            main_variant = "u-shaped";
          } else if (seaterValue.toLowerCase().includes("sectional")) {
            main_variant = "sectional";
          }
        
          // Show relevant seater variants
          const seaterVariants = $(`.seater-variant[seater-variant="${escapeSelector(main_variant)}"]`);
          seaterVariants.show();
        
          const seaterItem = seaterVariants.filter(function () {
            return $(this).attr("seater-value") === seaterValue;
          });
        
          if (seaterItem.length) {
            seaterItem.addClass("active");
            $(".selected_seater_title").text(seaterValue);
          } else {
            console.warn("Seater item not found for value:", seaterValue);
          }
        }
                
        // Apply color
        if (label.includes("color") || label.includes("colour")) {
          $(".product_color_values").removeClass("active_color");
          $(".product_color_values").removeClass("active");
        
          const colorItem = $(".product_color_values").filter(function () {
            return $(this).data("color") === value;
          });
        
          if (colorItem.length) {
            colorItem.addClass("active_color");
            colorItem.addClass("active");
            $(".selected_color_name").text(value);
          } else {
            console.warn("Color item not found for value:", value);
          }
        }
        
      }
    }
  } else {
    // Fallback: select the first of each type
    const firstConfigItem = $(".configuration-options .config-item").first();
    firstConfigItem.addClass("active_configure");
    firstConfigItem.addClass("active");
    $("#selected-config").text(firstConfigItem.data("config-value"));
  
    const config_name = firstConfigItem.attr("data-config-name");
    const seaterVariants = $(`.seater-variant[seater-variant="${config_name}"]`);
    const firstSeater = seaterVariants.first();
    seaterVariants.show();
    firstSeater.addClass("active");
    $(".selected_seater_title").text(firstSeater.attr("seater-value"));
  
    const firstColor = $(".product_color_values").first();
    firstColor.addClass("active_color");
    firstColor.addClass("active");
    $(".selected_color_name").text(firstColor.data("color"));
  }


  function formatPrice(price) {
    return price.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function renderProductGalleryByVariantId(matching_variant_id) {
    if ($('.productGalleryWrapper').length === 0) return;

    $('.heroGalleryWrapper.originalGallery #real-gallery').hide();
    $('.heroGalleryWrapper.originalGallery .shimmerGallery').show();

    let parent_slider = '';
    let child_slider = '';
    let main_slider = '';

    $('.productGalleryWrapper .productGalleryInner.productGalleryOriginal .hero-video-wrapper').each(function () {
      const index = $(this).attr('data-loop');

      if ($(this).attr('data-variant-id') == matching_variant_id) {
        let parent_slide = '';
        let child_slide = '';

        // Generate parent slides
        $(this).find('.product-gallery-parent').each(function () {
          const loop_index = $(this).attr('data-index');
          let slide = '';

          if ($(this).attr('data-has-video') === 'true') {
            slide = `<div class="pswp__custom-video-wrapper">
                <video
                  class="hero-video pdpGalleryVideo hide"
                  autoplay
                  loop
                  muted
                  playsInline
                  aria-label="Hero Video"
                  poster=""
                >
                  <source src="" type="video/mp4">
                </video>
              </div>`;
          }else {
            const image = $(this).attr('data-image-url');
            let aspectRatio = '59/43';
            if(loop_index == 0){
              slide = `<img src="${image}" srcset="${image}" sizes="100vw" alt="image" class="hero-video" fetchpriority="high" loading="eager" width="767" height="559" style="aspect-ratio:${aspectRatio};">`;
            }else{
              slide = `<img src="${image}" srcset="${image}" sizes="100vw" alt="image" class="hero-video" fetchpriority="low" loading="lazy" width="767" height="559" style="aspect-ratio:${aspectRatio};">`;
            }
          }

          parent_slide += `<div class="swiper-slide product_media_list" data-slide="${loop_index}">${slide}<div class="product__zoom"><button id="enable-zoom"><i class="fa-solid fa-magnifying-glass-plus"></i></button></div></div>`;
        });

        // Generate child (thumbnail) slides
        $(this).find('.product-thumbnails').each(function () {
          const loop_index = $(this).attr('data-index');
          let slide = '';
          let thumbaspectRatio = '13/12';

          if ($(this).attr('data-has-video') === 'true') {
            const image = $(this).attr('data-video-thumb');
            const video = $(this).attr('data-video-url');
            slide = `<img class="cms-slide pdpThumbnailVideo" var-id="${matching_variant_id}" src="${image}" srcset="${image}" data-video-url="${video}" width="130" height="120" style="aspect-ratio:${thumbaspectRatio};">`;
          } else {
            const image = $(this).attr('data-product-thumb');
            slide = `<img class="cms-slide" var-id="${matching_variant_id}" src="${image}" srcset="${image}" loading="lazy" width="130" height="120" style="aspect-ratio:${thumbaspectRatio};">`;
          }

          child_slide += `<div role="listitem" class="swiper-slide w-dyn-item w-col w-col-3" data-slide="${loop_index}">${slide}</div>`;
        });

        // Assemble parent slider
        if (parent_slide) {
          parent_slider = `
            <div class="product_media">
              <div class="product_main_slider swiper swiper-${index} product_main_slider-${index}">
                <div class="swiper-wrapper product_slider_media">
                  ${parent_slide}
                </div>
              </div>
            </div>`;
        }

        // Assemble child slider
        if (child_slide) {
          child_slider = `
            <div class="product_thumbnail_slider product_thumbnail_slider-${index}">
              <div class="swiper is-slider-main w-dyn-list product_meta_swiper swiper-${index} product_meta_swiper-${index}"
                udy-collection="cfp" id="${matching_variant_id}">
                <div role="list" class="swiper-wrapper is-slider-main w-dyn-items w-row">
                  ${child_slide}
                </div>
              </div>
              <div class="thumbs_pagination"></div>
              <div class="swiper-button-prev swiper-button-prev-${index}"></div>
              <div class="swiper-button-next swiper-button-next-${index}"></div>
            </div>`;
        }

        // Combine both sliders into main wrapper
        if (parent_slider && child_slider) {
          main_slider = `
            <div class="hero-video other firts_product_media bg-hero cls-${matching_variant_id}" product-media-variant="${matching_variant_id}">
              ${parent_slider}
              ${child_slider}
            </div>`;
        }

        // Inject into DOM
        if (main_slider) {
          setTimeout(function(){
            $('.heroGalleryWrapper.originalGallery #real-gallery').html(main_slider);
            var variants_size = $('.productGalleryWrapper').attr('data-variant-size');
            initializeGallerySwipers(variants_size);
            $('.heroGalleryWrapper.originalGallery #real-gallery').show();
            $('.heroGalleryWrapper.originalGallery .shimmerGallery').hide();
          }, 500);
          
        }
      }
    });
  }



  function renderProductGalleryLifestyleByVariantId(matching_variant_id) {
    if ($('.productGalleryWrapper').length === 0) return;

    $('.heroGalleryWrapper.lifestyleGallery #real-gallery').hide();
    $('.heroGalleryWrapper.lifestyleGallery .shimmerGallery').show();

    let parent_slider = '';
    let child_slider = '';
    let main_slider = '';

    $('.productGalleryWrapper .productGalleryInner.productGalleryLifestyle .hero-video-wrapper').each(function () {
      const index = $(this).attr('data-loop');

      if ($(this).attr('data-variant-id') == matching_variant_id) {
        let parent_slide = '';
        let child_slide = '';

        // Generate parent slides
        $(this).find('.product-gallery-parent').each(function () {
          const loop_index = $(this).attr('data-index');
          let slide = '';

          if ($(this).attr('data-has-video') === 'true') {
            slide = `<div class="pswp__custom-video-wrapper">
                <video
                  class="hero-video pdpGalleryVideo hide"
                  autoplay
                  loop
                  muted
                  playsInline
                  aria-label="Hero Video"
                  poster=""
                >
                  <source src="" type="video/mp4">
                </video>
              </div>`;
          }else {
            const image = $(this).attr('data-image-url');
            if(loop_index == 0){
              slide = `<img src="${image}" sizes="100vw" alt="image" class="hero-video" fetchpriority="high" loading="eager">`;
            }else{
              slide = `<img src="${image}" sizes="100vw" alt="image" class="hero-video" fetchpriority="high" loading="lazy">`;
            }
            
          }

          parent_slide += `<div class="swiper-slide product_media_list" data-slide="${loop_index}">${slide}<div class="product__zoom"><button id="enable-zoom"><i class="fa-solid fa-magnifying-glass-plus"></i></button></div></div>`;
        });

        // Generate child (thumbnail) slides
        $(this).find('.product-thumbnails').each(function () {
          const loop_index = $(this).attr('data-index');
          let slide = '';

          if ($(this).attr('data-has-video') === 'true') {
            const image = $(this).attr('data-video-thumb');
            const video = $(this).attr('data-video-url');
            slide = `<img class="cms-slide pdpThumbnailVideo" var-id="${matching_variant_id}" src="${image}" data-video-url="${video}">`;
          } else {
            const image = $(this).attr('data-product-thumb');
            slide = `<img class="cms-slide" var-id="${matching_variant_id}" src="${image}" loading="lazy">`;
          }

          child_slide += `<div role="listitem" class="swiper-slide w-dyn-item w-col w-col-3" data-slide="${loop_index}">${slide}</div>`;
        });

        // Assemble parent slider
        if (parent_slide) {
          parent_slider = `
            <div class="product_media">
              <div class="product_main_slider swiper swiper-${index} product_main_slider-${index}">
                <div class="swiper-wrapper product_slider_media">
                  ${parent_slide}
                </div>
              </div>
            </div>`;
        }

        // Assemble child slider
        if (child_slide) {
          child_slider = `
            <div class="product_thumbnail_slider product_thumbnail_slider-${index}">
              <div class="swiper is-slider-main w-dyn-list product_meta_swiper swiper-${index} product_meta_swiper-${index}"
                udy-collection="cfp" id="${matching_variant_id}">
                <div role="list" class="swiper-wrapper is-slider-main w-dyn-items w-row">
                  ${child_slide}
                </div>
              </div>
              <div class="thumbs_pagination"></div>
              <div class="swiper-button-prev swiper-button-prev-${index}"></div>
              <div class="swiper-button-next swiper-button-next-${index}"></div>
            </div>`;
        }

        // Combine both sliders into main wrapper
        if (parent_slider && child_slider) {
          main_slider = `
            <div class="hero-video other firts_product_media bg-hero cls-${matching_variant_id}" product-media-variant="${matching_variant_id}">
              ${parent_slider}
              ${child_slider}
            </div>`;
        }

        // Inject into DOM
        if (main_slider) {
          setTimeout(function(){
            $('.heroGalleryWrapper.lifestyleGallery #real-gallery').html(main_slider);
            var variants_size = $('.productGalleryWrapper').attr('data-variant-size');
            initializeGallerySwipersLifestyle(variants_size);
            $('.heroGalleryWrapper.lifestyleGallery #real-gallery').show();
            $('.heroGalleryWrapper.lifestyleGallery .shimmerGallery').hide();
          }, 500);
          
        }
      }
    });
  }

  function initializeGallerySwipers(variantCount) {
    for (let i = 1; i <= variantCount; i++) {
      const product_thumbs_swiper = new Swiper(`.heroGalleryWrapper.originalGallery .product_meta_swiper-${i}`, {
        slidesPerView: 4,
        watchSlidesProgress: true,
        spaceBetween: 20,
        grabCursor: true,
        navigation: {
          nextEl: `.swiper-button-next-${i}`,
          prevEl: `.swiper-button-prev-${i}`
        },
        breakpoints: {
          300: {
            slidesPerView: 5,
            spaceBetween: 5
          },
          1150: {
            slidesPerView: 4,
            spaceBetween: 10
          }
        }
      });

      const main_slider = new Swiper(`.heroGalleryWrapper.originalGallery .product_main_slider-${i}`, {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: `.main_pagination-${i}`,
          clickable: true
        },
        thumbs: {
          swiper: product_thumbs_swiper
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const sourceHtml = $('.PdpVideoWrapper video').html();
            const videoUrl = $('.PdpVideoWrapper video source').attr('src');

            const $sliderContainer = $(this.el).closest('.hero-video');

            $sliderContainer.find('.product_media_list').each(function () {
              const slideIndex = parseInt($(this).attr('data-slide'), 10);

              const $video = $(this).find('.pswp__custom-video-wrapper video');
              const $source = $video.find('source');
              const $img = $(this).find('.pswp__custom-video-wrapper img');

              if (slideIndex === activeIndex) {
                if ($video.length > 0 && $source.length > 0) {
                  if ($source.attr('src') !== videoUrl) {
                    $video.html(sourceHtml);
                    $video[0].load();
                  }

                  $video.removeClass('hide');
                  $video[0].play();

                  $video.off('play').on('play', function () {
                    $img && $img.length && $img.addClass('hide');
                  });
                }
              } else {
                if ($video.length > 0 && $video[0]) {
                  $video[0].pause();
                  $video.addClass('hide');
                  $img && $img.length && $img.removeClass('hide');
                }
              }
            });
          }
        }
      });
    }
  }

  function initializeGallerySwipersLifestyle(variantCount) {
    for (let i = 1; i <= variantCount; i++) {
      const product_thumbs_swiper = new Swiper(`.heroGalleryWrapper.lifestyleGallery .product_meta_swiper-${i}`, {
        slidesPerView: 4,
        watchSlidesProgress: true,
        spaceBetween: 20,
        grabCursor: true,
        navigation: {
          nextEl: `.swiper-button-next-${i}`,
          prevEl: `.swiper-button-prev-${i}`
        },
        breakpoints: {
          300: {
            slidesPerView: 5,
            spaceBetween: 5
          },
          1150: {
            slidesPerView: 4,
            spaceBetween: 10
          }
        }
      });

      const main_slider = new Swiper(`.heroGalleryWrapper.lifestyleGallery .product_main_slider-${i}`, {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: `.main_pagination-${i}`,
          clickable: true
        },
        thumbs: {
          swiper: product_thumbs_swiper
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const sourceHtml = $('.PdpVideoWrapper video').html();
            const videoUrl = $('.PdpVideoWrapper video source').attr('src');

            const $sliderContainer = $(this.el).closest('.hero-video');

            $sliderContainer.find('.product_media_list').each(function () {
              const slideIndex = parseInt($(this).attr('data-slide'), 10);

              const $video = $(this).find('.pswp__custom-video-wrapper video');
              const $source = $video.find('source');
              const $img = $(this).find('.pswp__custom-video-wrapper img');

              if (slideIndex === activeIndex) {
                if ($video.length > 0 && $source.length > 0) {
                  if ($source.attr('src') !== videoUrl) {
                    $video.html(sourceHtml);
                    $video[0].load();
                  }

                  $video.removeClass('hide');
                  $video[0].play();

                  $video.off('play').on('play', function () {
                    $img && $img.length && $img.addClass('hide');
                  });
                }
              } else {
                if ($video.length > 0 && $video[0]) {
                  $video[0].pause();
                  $video.addClass('hide');
                  $img && $img.length && $img.removeClass('hide');
                }
              }
            });
          }
        }
      });
    }
  }


  // Modified product_data function to dynamically match variant options by option name
  function product_data(active_config_name, active_seater, active_color) {
    
    $('.mainProduct .firts_product_media').addClass('hide');
    let matching_variant_id = null;
  
    $('.modular_variants option').each(function () {
      const variantOptions = {
        option1: $(this).attr('variant-option1') || '',
        option2: $(this).attr('variant-option2') || '',
        option3: $(this).attr('variant-option3') || ''
      };
  
      const match = (
        (!active_config_name || active_config_name === variantOptions.option1 || active_config_name === variantOptions.option2 || active_config_name === variantOptions.option3) &&
        (!active_seater || active_seater === variantOptions.option1 || active_seater === variantOptions.option2 || active_seater === variantOptions.option3) &&
        (!active_color || active_color === variantOptions.option1 || active_color === variantOptions.option2 || active_color === variantOptions.option3)
      );
  
      if (match) {
        matching_variant_id = $(this).attr('variant-id');
        return false;
      }
    });
  
    if (!matching_variant_id) return; // Early return if no match
  
    /* $('.product_meta_size_information, .product_meta_size_accordion, .product_meta_popup_variant, .variant_estimate_date').addClass('hide');
    $(`.product_meta_size_information[variant-size-id="${matching_variant_id}"]`).removeClass('hide');
    $(`.product_meta_size_accordion[variant-size-id="${matching_variant_id}"]`).removeClass('hide');
    
    $(`.product_meta_popup_variant[product-var-id="${matching_variant_id}"]`).siblings().addClass('hide');
    $(`.product_meta_popup_variant[product-var-id="${matching_variant_id}"]`).removeClass('hide'); */

    
    $('.variant_estimate_date').addClass('hide');
    $(`.product_meta_size_information`).attr('variant-size-id', matching_variant_id);
    $(`.product_meta_popup_variant`).attr('product-var-id', matching_variant_id);
    $(`product_meta_size_accordion`).attr('variant-size-id', matching_variant_id);

    var sizeguide_popup_content = $(`.contentSizeguide-multiple-section .productSizeGuideInfo[data-var-id="${matching_variant_id}"] .productPopupInformation`).html();
    var sizeguide_accordion_content = $(`.contentSizeguide-multiple-section .productSizeGuideInfo[data-var-id="${matching_variant_id}"] .productAccordionInformation`).html();
    var sizeguide_section_content = $(`.contentSizeguide-multiple-section .productSizeGuideInfo[data-var-id="${matching_variant_id}"] .productSizeInformation`).html();

    if(sizeguide_popup_content){
      $(`.product_meta_popup_variant`).html(sizeguide_popup_content)
    }

    if(sizeguide_accordion_content){
      $(`.product_meta_size_accordion`).html(sizeguide_accordion_content)
    }

    if(sizeguide_section_content){
      $(`.product_meta_size_information`).html(sizeguide_section_content)
    }


    // SALE PRICE LOGIC
    const currentUrl = window.location.pathname;
    if (currentUrl.includes('/cushie-modular-sleeper-sofa')) {
      const optionElement = $(`.modular_variants option[variant-id="${matching_variant_id}"]`);
      const sale_price = parseFloat(optionElement.attr('variant-sale-price'));
      const discount_number = parseFloat($('.discount_value').attr('discount'));

      console.log(matching_variant_id);
  
      if (!isNaN(sale_price) && !isNaN(discount_number)) {
        const discounted_price = sale_price - (sale_price * discount_number / 100);
        const sale_discount_price = Shopify.formatMoney(discounted_price);
      }
  
      const percentValue = parseFloat($('.sale_left_content').data('percent-value')) || 0;
      const minusValue = parseFloat($('.sale_left_content').data('minus-value')) || 0;
  
      let variantPrice = percentValue > 0
        ? (sale_price - (sale_price * percentValue / 100)).toFixed(2)
        : (sale_price - minusValue).toFixed(2);
  
      $('span.variant-price').text(formatCushieMoney(variantPrice));
      $('span.original-price>s').text(formatCushieMoney(sale_price));

    }

    
    let current_variant_id = '';
    var selected_variant_title = '';

    if($('.pdpVariantData').length > 0){
      if($('.variant-productOption').length > 0){
        var total_options = $('.variant-productOption').length;
        var option1 = ''; 
        var option2 = '';
        var option3 = '';
        if(total_options == 1){
          option1 = $('.variant-productOption[data-option-id="0"] .active').attr('data-value');
          var selected_variant_title = option1;
        }else if(total_options == 2){
          option1 = $('.variant-productOption[data-option-id="0"] .active').attr('data-value');
          option2 = $('.variant-productOption[data-option-id="1"] .active').attr('data-value');
          var selected_variant_title = option1+' / '+option2;
        }else if(total_options == 3){
          option1 = $('.variant-productOption[data-option-id="0"] .active').attr('data-value');
          option2 = $('.variant-productOption[data-option-id="1"] .active').attr('data-value');
          option3 = $('.variant-productOption[data-option-id="2"] .active').attr('data-value');
          var selected_variant_title = option1+' / '+option2+' / '+option3;
        }


        if(selected_variant_title){
          current_variant_id = $(".pdpVariantData li[data-title='"+selected_variant_title+"']").attr('data-vid');
        }

      }
    }

    if (!currentUrl.includes('/sleeper-sofa-2-01')) {
      renderProductGalleryByVariantId(current_variant_id);
    }



if (current_variant_id && current_variant_id !== 'undefined') {

  // $('.stock-status-card').addClass('op');
  $('.stock-status-card').addClass('loading');
  var market = $('body').attr('data-market');
  // ✅ fallback (in case something breaks)
  setTimeout(() => {
    $('.stock-status-card').removeClass('loading');
  }, 3000);
  fetchInventory(current_variant_id).then(inventory => {
    if (!Array.isArray(inventory)) return;

    let available_stock_arr = [];

    for (var i = 0; i < inventory.length; i++) {
      var item = inventory[i];
      if (!item || !item.location) continue;

      if (market === 'uk') {
        if(item.location == 'UK Warehouse'){
          let available_stock = item.quantity;
          if(available_stock <= 0){
            var uk_preorder = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-uk-preorder');
            var uk_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-uk-date');

            renderPreOrderOrSoldOut(current_variant_id, uk_preorder, uk_delivery_date);

          }else{
            $('.stock-status-card .shipment-header').html(`<span class="status-dot in-stock"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9.5" cy="9.5" r="5" fill="#59A169"/>
              <circle cx="9.5" cy="9.5" r="6.875" stroke="#59A169" stroke-opacity="0.3" stroke-width="3.75"/>
              </svg>
              </span>
              <strong>In stock, ships in 1-2 business days </strong>`);

            $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('In Warehouse Now');
            $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html(`<strong>In Stock, Ships in 1-2 days</strong>`);

            $('#primar-button').val('Add to cart');
            $('#primar-button').attr('data-value', 'Add to cart');
            enablePrimaryCartButton();
            $('#primar-button').closest('.atcButtonWrap').find('.cart_pre_order_icon').attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/shopping-cart-white.svg?v=1756128418');
              
            // $('.stock-status-card').removeClass('op');
            $('.stock-status-card').removeClass('loading');
          }
        }
      }else if (market === 'canada') {
        if(item.location == 'CA Warehouse'){
          let available_stock = item.quantity;
          if(available_stock <= 0){
            var ca_preorder = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-ca-preorder');
            var ca_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-ca-date');

            renderPreOrderOrSoldOut(current_variant_id, ca_preorder, ca_delivery_date);

          }else{
            $('.stock-status-card .shipment-header').html(`<span class="status-dot in-stock"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9.5" cy="9.5" r="5" fill="#59A169"/>
              <circle cx="9.5" cy="9.5" r="6.875" stroke="#59A169" stroke-opacity="0.3" stroke-width="3.75"/>
              </svg>
              </span>
              <strong>In stock, ships in 1-2 business days </strong>`);

            $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('In Warehouse Now');
            $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html(`<strong>In Stock, Ships in 1-2 days</strong>`);

            $('#primar-button').val('Add to cart');
            $('#primar-button').attr('data-value', 'Add to cart');
            enablePrimaryCartButton();
            $('#primar-button').closest('.atcButtonWrap').find('.cart_pre_order_icon').attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/shopping-cart-white.svg?v=1756128418');

            // $('.stock-status-card').removeClass('op');
            $('.stock-status-card').removeClass('loading');
            
          }
        }
      }else{

        if(item.location == 'USA PAW Warehouse' || item.location == 'USA NJF Warehouse' || item.location == 'USA CAP Warehouse'){
          
          if(item.location == 'USA PAW Warehouse'){
            available_stock_arr.push(item.quantity);
          }
          if(item.location == 'USA NJF Warehouse'){
            available_stock_arr.push(item.quantity);
          }
          if(item.location == 'USA CAP Warehouse'){
            available_stock_arr.push(item.quantity);
          }

          var totalAvailableStock = available_stock_arr.reduce(function(sum, num) {
            return sum + (parseInt(num, 10) || 0);
          }, 0);
          var hasStock = totalAvailableStock > 0;

          if(hasStock == true){
            $('.stock-status-card .shipment-header').html(`<span class="status-dot in-stock"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9.5" cy="9.5" r="5" fill="#59A169"/>
              <circle cx="9.5" cy="9.5" r="6.875" stroke="#59A169" stroke-opacity="0.3" stroke-width="3.75"/>
              </svg>
              </span>
              <strong>In stock, ships in 1-2 business days </strong>`);

            $('.stock-status-card .timeline .timeline-item[data-id="1"] .datelabel').text('In Warehouse Now');
            $('.stock-status-card .timeline .timeline-item[data-id="1"] .datecontent').html(`<strong>In Stock, Ships in 1-2 days</strong>`);

            $('#primar-button').val('Add to cart');
            $('#primar-button').attr('data-value', 'Add to cart');
            enablePrimaryCartButton();
            $('#primar-button').closest('.atcButtonWrap').find('.cart_pre_order_icon').attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/shopping-cart-white.svg?v=1756128418');

            // $('.stock-status-card').removeClass('op');
            $('.stock-status-card').removeClass('loading');

          }else{
            var us_preorder = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-us-preorder');
            var us_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-us-date');

            renderPreOrderOrSoldOut(current_variant_id, us_preorder, us_delivery_date);

          }
        }
        
      }
    }
  });
}

//------------------------------------------------
    $('.variant_estimate_date').each(function(){
      var ship_date_var_id = $(this).attr('data-variant');
      var ship_pre_order_date = $(this).attr('data-ship-date');
      var inventory_qty = $(this).attr('variant-quantity');
      var inventory_policy = $(this).attr('variant-inventory-policy');

      var preOrder = 'No';
      if(inventory_qty <= 0 && inventory_policy == 'continue'){
        preOrder = 'Yes';
      }
     
      if(current_variant_id != null){
        if (current_variant_id == ship_date_var_id) {
          $('.variant_estimate_date[data-variant="' + current_variant_id + '"]').removeClass('hide');
          $('.instock_estimate_days').addClass('hide');
          var date_text = ship_pre_order_date;
          // $('input[name="properties[Dispatch Date]"]').val(date_text);
        }else {
          $('.instock_estimate_days').removeClass('hide');
          // $('input[name="properties[Dispatch Date]"]').val(ship_pre_order_date);
        }
      }else{
        if (matching_variant_id == ship_date_var_id) {
          $('.variant_estimate_date[data-variant="' + matching_variant_id + '"]').removeClass('hide');
          $('.instock_estimate_days').addClass('hide');
          var date_text = ship_pre_order_date;
          // $('input[name="properties[Dispatch Date]"]').val(date_text);
        } else {
          $('.instock_estimate_days').removeClass('hide');
          // $('input[name="properties[Dispatch Date]"]').val(ship_pre_order_date);
        }
      }
    })
  

    $(`.product_delivery_meta_content`).addClass('hide');
    $(`.product_delivery_meta_content[variant-id="${matching_variant_id}"]`).removeClass('hide');

    $(`.firts_product_media`).addClass('hide');
    $(`.firts_product_media[product-media-variant="${matching_variant_id}"]`).removeClass('hide');
  
    const currentURL = new URL(window.location.href);
    const path_url = window.location.pathname.split('/')[2];
    if (path_url === "cushie-modular-sleeper-sofa") {
      currentURL.searchParams.set('variant', matching_variant_id);
      $('input[name="id"]').val(matching_variant_id);
      window.history.pushState(null, '', currentURL.toString());
    }
  
    const option = $(`.modular_variants option[variant-id="${matching_variant_id}"]`);
    const current_variant_qty = parseInt(option.attr('variant-qty'));
    const stock_available = option.attr('variant-stock') === 'true';
    const variant_price = option.attr('variant-price');

    let variant_price_numeric = parseFloat(variant_price.replace(/[^0-9.]/g, "")) || 0;
  
    $('.modular_sofa .main_price span, .custom-container.pdp-menu .product-price.pdp, .prd_comp_price .product_tier_comp_price').text(variant_price);

    if($('.sticky-atc-wrapper').length > 0){
      
      let variantEl = $(".pdpVariantData li").filter(function() {
        return $(this).attr("data-title") === selected_variant_title;
      });

      let sale_enable = variantEl.attr("data-sale-enable");
      let sale_percent = parseFloat(variantEl.attr("data-discount")) || 0;

      const hasActiveMarketSale = sale_enable === 'true' && sale_percent > 0;
      if($('.sticky-atc-wrapper span.atc-current-price').hasClass('atc-tier-current-price')){
        $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice .atc-tier-compare-at').text(hasActiveMarketSale ? variant_price : '').toggle(hasActiveMarketSale);
      }else{
        if (hasActiveMarketSale) {
          var difference = parseFloat((variant_price_numeric * sale_percent) / 100);
          var sale_price = variant_price_numeric - difference;
          sale_price = sale_price.toFixed(2);

          const formattedsp = formatCushieMoney(sale_price);

          $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice .atc-compare-at')
            .text(variant_price);
          
          $('.product_menu_section .sticky-bar-price span.atc-compare-at').text(variant_price);

          // Set discounted price
          $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice span.atc-current-price span.currentPrice')
            .text(formattedsp);

          $('.product_menu_section .sticky-bar-price span.atc-current-price .currentPrice').text(formattedsp);

        } else {
          // Set regular price and clear stale RRP/compare price
          $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice .atc-compare-at').text('').hide();
          $('.product_menu_section .sticky-bar-price span.atc-compare-at').text('').hide();
          $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice span.atc-current-price span.currentPrice').text(variant_price); 
          $('.product_menu_section .sticky-bar-price span.atc-current-price .currentPrice').text(variant_price);
          
        }
        
      }
    } 
  
     if (variant_price) {
      let tier_discount = 0;
      const cleanPrice = parseFloat(variant_price.replace(/[^0-9.]/g, ''));
      const monthly = (cleanPrice / 12).toFixed(2);
      $('.metafield-string').html(formatCushieMoney(monthly) + '/Month');

      // Determine tier discount
      if (cleanPrice >= 500 && cleanPrice < 1200) {
        tier_discount = 15;
      } else if (cleanPrice >= 1200 && cleanPrice < 2000) {
        tier_discount = 20;
      } else if (cleanPrice >= 2000) {
        tier_discount = 25;
      }

      // Calculate discounted price
      let newSalePrice = 0;
      if (tier_discount > 0) {
        const difference = (cleanPrice * tier_discount) / 100;
        newSalePrice = cleanPrice - difference;
      }

      // Update DOM
      if (newSalePrice > 0) {
        newSalePrice = formatCushieMoney(newSalePrice);
        if($('.price-text-holder .main_price1').length > 0){
          $('.price-text-holder .main_price1 span').text(newSalePrice);
        }
        
        if($('.sticky-atc-wrapper').length > 0){
          if($('.sticky-atc-wrapper span.atc-current-price').hasClass('atc-tier-current-price')){
            $('.sticky-atc-wrapper .sticky-atc-container .atc-row .atc-col-right .atc-inner-row .atcPrice span.atc-tier-current-price span.currentPrice').text(newSalePrice);
          }
        }
      } 

    }else {
      $('.metafield-string').html('');
    }
  
    $('.pre_order_information').hide();
    if (current_variant_qty <= 0) {
      $('.stock_label').text('Low Stock').show();
    } else if (current_variant_qty <= 10) {
      $('.stock_label').text(`Only ${current_variant_qty} Left`).show();
    } else {
      $('.stock_label').text('Low in Stock').hide();
    }
  
    if (!stock_available && current_variant_qty <= 0) {
      $('.add-to-cart-holder .cart_pre_order_icon').hide();
      $('#primar-button').val('Out Of Stock').prop('disabled', true);
      $('#primar-button').attr('data-value', 'Out Of Stock');
      $('.tooltip_icon, .delivery_banner').hide();
    }else if (current_variant_qty <= 0) {
      if($('body').attr('data-market') == 'us'){
        $('#primar-button').val('Pre-Order').prop('disabled', false);
        $('#primar-button').attr('data-value', 'Pre-Order');
        $('.add-to-cart-holder .cart_pre_order_icon')
          .attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/timer.png?v=1747280079')
          .addClass('pre-order')
          .show(); 
      }
      // $('.pre_order_information[variant-id="' + matching_variant_id + '"]').show();
      $('.tooltip_icon').show();
      $('.delivery_banner').hide();
      $('.ship_stock_text').text('Pre-Order');
    }else {
      if($('body').attr('data-market') == 'us'){
        $('#primar-button').val('Add To Cart').prop('disabled', false);
        $('#primar-button').attr('data-value', 'Add To Cart');
        $('.add-to-cart-holder .cart_pre_order_icon')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0745/0876/3427/files/shopping-cart-white.svg?v=1756128418')
        .removeClass('pre-order')
        .show(); 
      }
      $('.pre-order-info-div, .tooltip_icon').hide();
      $('.delivery_banner').show();
      $('.ship_stock_text').text('In Stock');
    }
  }
  
  // Usage:
  product_data(active_config_name, active_seater, active_color);
    

  $(document).on('click','.configuration-options .config-item', function(){
    $('.seater-variant').hide();
    $('.seater-variant').removeClass('active');
    $('.configuration-options .config-item').removeClass('active_configure');
    $(this).addClass('active_configure');
    $('.configuration-options .config-item').removeClass('active');
    $(this).addClass('active');
    var click_config = $(this).attr('data-config-name');
    var selected_config = $(this).attr('data-config-value');

    $('#selected-config').text(selected_config);

    $('.seater-variant[seater-variant="' + escapeSelector(click_config) + '"]').show();
    $('.seater-variant[seater-variant="' + escapeSelector(click_config) + '"]').first().addClass('active');
    var selected_seater_value = $('.seater-variant[seater-variant="' + escapeSelector(click_config) + '"]').first().attr('seater-value');
    $('.selected_seater_title').text(selected_seater_value);

    // ============ Active Variant Data ==============
    var change_seater = $('.seater-variant.active').attr('seater-value');
    var change_color = $('.product_color_values.active_color').attr('data-color');
    
    product_data(selected_config, change_seater, change_color);

  }); 

  $('.seater-variant').click(function(){
      $('.seater-variant').removeClass('active');
      $(this).addClass('active');

      var select_seater_value = $(this).attr('seater-value');
      $('.selected_seater_title').text(select_seater_value);

      // ============ Active Variant Data ==============
      var change_config = $('.config-item.active_configure').attr('data-config-value');
      var change_color = $('.product_color_values.active_color').attr('data-color');
      product_data(change_config, select_seater_value, change_color);
  });

  $('.product_color_values').click(function(){
      $('.product_color_values').removeClass('active_color');
      $(this).addClass('active_color');
      $('.product_color_values').removeClass('active');
      $(this).addClass('active');
      var selected_color = $(this).attr('data-color');
      $('.selected_color_name').text(selected_color);
      // ============ Active Variant Data ==============
      var change_config = $('.config-item.active_configure').attr('data-config-value');
      var change_seater = $('.seater-variant.active').attr('seater-value');
      product_data(change_config, change_seater, selected_color);
  });

});


// Ensure jQuery and Shopify are available
if (typeof jQuery === 'undefined' || typeof Shopify === 'undefined') {
  console.error('jQuery or Shopify not loaded');
} else {
  jQuery(document).ready(function($) {
    const currentUrl = window.location.pathname;

    setTimeout(function() {
      var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
      // $('#properties').val(variation_date);
    }, 500);

    // Only bind events if on the correct page
    if (currentUrl.includes('/sleeper-sofa-2-01')) {
      // Use event delegation for dynamically added .variation-swatch elements
      $(document).on('click', '.variation-swatch', function() {

        var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
        // $('#properties').val(variation_date);
        // Get data-variant-price from the clicked variation-swatch
        const salePrice = $(this).data('variant-price');
        if (!salePrice) {
          console.error('No variant price found');
          return;
        }

        // Get discount values
        const percentValue = parseFloat($('.sale_left_content').data('percent-value')) || 0;
        const minusValue = parseFloat($('.sale_left_content').data('minus-value')) || 0;

        // Clean and parse salePrice (remove commas)
        const originalPrice = parseFloat(salePrice.replace(/,/g, '')) || 0;

        // Calculate variant price
        let variantPrice;
        if (percentValue > 0) {
          // Apply percentage discount
          variantPrice = (originalPrice - (originalPrice * percentValue / 100)).toFixed(2);
          // console.log('variantPrice%:', variantPrice);
        } else {
          // Subtract minus-value
          variantPrice = (originalPrice - minusValue).toFixed(2);
          // console.log('variantPrice-:', variantPrice);
        }

        // console.log('originalPrice:', originalPrice);

        // Update prices using Shopify.formatMoney
        // Ensure Shopify.formatMoney is available and format is correct
        $('span.variant-price').text(formatCushieMoney(variantPrice));
        $('span.original-price > s').text(formatCushieMoney(originalPrice));
      });
    }else{
      $(document).on('click', '.variation-swatch', function() {
        var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
        // $('#properties').val(variation_date);
      });
    }
  });
}



$(document).on('click','.variant-productOption .selectvarentcc', function(){
  var total_options = $('.variant-productOption').length;
  var selected_option1 = ''; var selected_option2 = ''; var selected_option3 = '';
  var selected_variant_name = '';
  var selected_variant_id = '';

  if(total_options == 1){
    selected_option1 = $('.variant-productOption[data-option-id="0"] .selectvarentcc.active').attr('data-value');

    selected_variant_name = selected_option1;

  }else if(total_options == 2){
    selected_option1 = $('.variant-productOption[data-option-id="0"] .selectvarentcc.active').attr('data-value');
    selected_option2 = $('.variant-productOption[data-option-id="1"] .selectvarentcc.active').attr('data-value');

    selected_variant_name = selected_option1+' / '+selected_option2;

  }else if(total_options == 3){
    selected_option1 = $('.variant-productOption[data-option-id="0"] .selectvarentcc.active').attr('data-value');
    selected_option2 = $('.variant-productOption[data-option-id="1"] .selectvarentcc.active').attr('data-value');
    selected_option3 = $('.variant-productOption[data-option-id="2"] .selectvarentcc.active').attr('data-value');

    selected_variant_name = selected_option1+' / '+selected_option2+' / '+selected_option3;
  }

  if(selected_variant_name){

    $('.pdpVariantData li').each(function(){
      var title = $(this).attr('data-title');
      if(title == selected_variant_name){
        selected_variant_id = $(this).attr('data-vid');
      }
    })

  }


  if(selected_variant_id){

    var market = $('body').attr('data-market');

    fetchInventory(selected_variant_id).then(inventory => {
      if (!Array.isArray(inventory)) return;

      let available_stock_arr = [];
      
      for (var i = 0; i < inventory.length; i++) {
        var item = inventory[i];
        if (!item || !item.location) continue;
        if (market === 'uk') {

          if(item.location == 'UK Warehouse'){
            let available_stock = item.quantity;
            var uk_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+selected_variant_id+'"]').attr('data-uk-date');

            if(available_stock <= 0){
             $('input[name="properties[Dispatch Date]"]').val(uk_delivery_date);
            }else{
              $('input[name="properties[Dispatch Date]"]').val('Ships in 1-2 days');
            }
          }

        }else if (market === 'canada') {

          if(item.location == 'CA Warehouse'){
            let available_stock = item.quantity;
            var ca_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+selected_variant_id+'"]').attr('data-ca-date');
            if(available_stock <= 0){
              $('input[name="properties[Dispatch Date]"]').val(ca_delivery_date);
            }else{
              $('input[name="properties[Dispatch Date]"]').val('Ships in 1-2 days');
            }
          }

        }else{
          if(item.location == 'USA PAW Warehouse' || item.location == 'USA NJF Warehouse' || item.location == 'USA CAP Warehouse'){
            if(item.location == 'USA PAW Warehouse'){
              available_stock_arr.push(item.quantity);
            }
            if(item.location == 'USA NJF Warehouse'){
              available_stock_arr.push(item.quantity);
            }
            if(item.location == 'USA CAP Warehouse'){
              available_stock_arr.push(item.quantity);
            }

            var totalAvailableStock = available_stock_arr.reduce(function(sum, num) {
              return sum + (parseInt(num, 10) || 0);
            }, 0);
            var hasStock = totalAvailableStock > 0;

            /* let available_stock = item.quantity;
            var us_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+selected_variant_id+'"]').attr('data-us-date');
            if(available_stock <= 0){
              $('input[name="properties[Dispatch Date]"]').val('Ships on '+us_delivery_date);
            }else{
              $('input[name="properties[Dispatch Date]"]').val('Ships in 1-2 days');
            } */

            var us_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+selected_variant_id+'"]').attr('data-us-date');
            if(hasStock == true){
              $('input[name="properties[Dispatch Date]"]').val('Ships in 1-2 days');
            }else{
              $('input[name="properties[Dispatch Date]"]').val(us_delivery_date);
            }

          }
          
        }
      }
    });
  }
})


if($('body').hasClass('template-cart')){
  var market = $('body').attr('data-market');

  $('.cart_items_ .cart-item-3').each(function(){
    var current_variant_id = $(this).attr('data-id');

    if(current_variant_id){
      fetchInventory(current_variant_id).then(inventory => {
        if (!Array.isArray(inventory)) return;

        let available_stock_arr = [];

        for (var i = 0; i < inventory.length; i++) {
          var item = inventory[i];
          if (!item || !item.location) continue;
          if (market === 'uk') {

            if(item.location == 'UK Warehouse'){
              let available_stock = item.quantity;
              var uk_delivery_date = $(this).attr('data-uk-preorder');
              if(available_stock <= 0){
                $('body').attr('uk-inventory', available_stock);
                $(this).find('.cart_item_properties').text(uk_delivery_date);
              }else{
                $('body').attr('uk-inventory', available_stock);
                $(this).find('.cart_item_properties').text('Ships in 1-2 days');
              }
            }

          }else if (market === 'canada') {

            if(item.location == 'CA Warehouse'){
              let available_stock = item.quantity;
              var ca_delivery_date = $(this).attr('data-ca-preorder');
              if(available_stock <= 0){
                $('body').attr('ca-inventory', available_stock);
                $(this).find('.cart_item_properties').text(ca_delivery_date);
              }else{
                $('body').attr('ca-inventory', available_stock);
                $(this).find('.cart_item_properties').text('Ships in 1-2 days');
              }
            }

          }else{
            if(item.location == 'USA PAW Warehouse' || item.location == 'USA NJF Warehouse' || item.location == 'USA CAP Warehouse'){
              /* let available_stock = item.quantity;
              var us_delivery_date = $(this).attr('data-us-preorder');
              if(available_stock <= 0){
                $('body').attr('us-inventory', available_stock);
                $(this).find('.cart_item_properties').text(us_delivery_date);
              }else{
                $('body').attr('us-inventory', available_stock);
                $(this).find('.cart_item_properties').text('Ships in 1-2 days');
              } */

              if(item.location == 'USA PAW Warehouse'){
                available_stock_arr.push(item.quantity);
              }
              if(item.location == 'USA NJF Warehouse'){
                available_stock_arr.push(item.quantity);
              }
              if(item.location == 'USA CAP Warehouse'){
                available_stock_arr.push(item.quantity);
              }

              var totalAvailableStock = available_stock_arr.reduce(function(sum, num) {
                return sum + (parseInt(num, 10) || 0);
              }, 0);
              var hasStock = totalAvailableStock > 0;

              var us_delivery_date = $(this).attr('data-us-preorder');
              let available_stock = totalAvailableStock;
              
              if(hasStock == true){
                $('body').attr('us-inventory', available_stock);
                $(this).find('.cart_item_properties').text('Ships in 1-2 days');
              }else{
                $('body').attr('us-inventory', available_stock);
                $(this).find('.cart_item_properties').text(us_delivery_date);
              }

            }
            
          }
        }
      });
    }

  })
  
}


if($('body').hasClass('template-product')){
  setTimeout(function(){
    var market = $('body').attr('data-market');
    var current_variant_id = $('#hero_top_link_aa').attr('data-vid');

    if(current_variant_id){
      fetchInventory(current_variant_id).then(inventory => {
        if (!Array.isArray(inventory)) return;

        let available_stock_arr = [];

        for (var i = 0; i < inventory.length; i++) {
          var item = inventory[i];
          if (!item || !item.location) continue;
          if (market === 'uk') {

            if(item.location == 'UK Warehouse'){
              let available_stock = item.quantity;
              var uk_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-uk-date');
              if(available_stock <= 0){
                $('body').attr('uk-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').val(uk_delivery_date);
              }else{
                $('body').attr('uk-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').val('Ships in 1-2 days');
              }
            }

          }else if (market === 'canada') {

            if(item.location == 'CA Warehouse'){
              let available_stock = item.quantity;   
              var ca_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-ca-date');

              if(available_stock <= 0){
                $('body').attr('ca-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').val(ca_delivery_date);
              }else{
                $('body').attr('ca-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').val('Ships in 1-2 days');
              }
            }

          }else{
            if(item.location == 'USA PAW Warehouse' || item.location == 'USA NJF Warehouse' || item.location == 'USA CAP Warehouse'){

              if(item.location == 'USA PAW Warehouse'){
                available_stock_arr.push(item.quantity);
              }
              if(item.location == 'USA NJF Warehouse'){
                available_stock_arr.push(item.quantity);
              }
              if(item.location == 'USA CAP Warehouse'){
                available_stock_arr.push(item.quantity);
              }

              var totalAvailableStock = available_stock_arr.reduce(function(sum, num) {
                return sum + (parseInt(num, 10) || 0);
              }, 0);
              var hasStock = totalAvailableStock > 0;

              /* let available_stock = item.quantity;
              var us_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-us-date');
              if(available_stock <= 0){
                $('body').attr('us-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').val(us_delivery_date);
              }else{
                $('body').attr('us-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').val('Ships in 1-2 days');
              } */

              let available_stock = totalAvailableStock;
              var us_delivery_date = $('.bulkUrgencyWrap .bulk-ug[data-vid="'+current_variant_id+'"]').attr('data-us-date');
              
              if(hasStock == true){
                $('body').attr('us-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').text('Ships in 1-2 days');
              }else{
                $('body').attr('us-inventory', available_stock);
                $('input[name="properties[Dispatch Date]"]').text(us_delivery_date);
              }

            }
            
          }
        }
      });
    }
  }, 1000);

}